/* global Cookiebot */

import { useEffect, useState } from "react";
import axios from "axios";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import TagManager from "react-gtm-module";

import { styled } from "@mui/material/styles";
import {
  Select,
  MenuItem,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  Checkbox,
  FormControl,
  OutlinedInput,
  Button,
  InputLabel,
  FormHelperText,
  TextField,
} from "@mui/material";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import { Comment } from "react-loader-spinner";

import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// STEP 01
import ico_website_webshop from "../assets/icons/ico-01.png";
import ico_cloud from "../assets/icons/ico-02.png";
import ico_dev from "../assets/icons/ico-03.png";
import ico_contact from "../assets/icons/ico-04.png";

// OTHER STEPS
import ico_website from "../assets/icons/ico-05.png";
import ico_webshop from "../assets/icons/ico-06.png";
import ico_new_program from "../assets/icons/ico-07.png";
import ico_relaunch from "../assets/icons/ico-relaunch.png";
import ico_product_small from "../assets/icons/ico-09.png";
import ico_product_middle from "../assets/icons/ico-10.png";
import ico_product_big from "../assets/icons/ico-11.png";
import ico_product_extra_big from "../assets/icons/ico-12.png";
import ico_company_small from "../assets/icons/ico-13.png";
import ico_company_middle from "../assets/icons/ico-14.png";
import ico_company_big from "../assets/icons/ico-15.png";
import ico_company_extra_big from "../assets/icons/ico-16.png";
import ico_tax from "../assets/icons/ico-17.png";
import ico_kmu from "../assets/icons/ico-18.png";
import ico_law from "../assets/icons/ico-19.png";
import ico_ohter_program from "../assets/icons/ico-20.png";
import ico_billing_program from "../assets/icons/ico-21.png";
import ico_customer_management_program from "../assets/icons/ico-22.png";
import ico_ohter_company_type from "../assets/icons/ico-sonstiges.png";

const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  ".MuiFormControlLabel-label": checked && {
    border: "3px solid #8da2b2 !important",
  },
}));

function ControlledLabelBox(props) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

const StepperForm = () => {
  const [cookieAccept, setCookieAccept] = useState(false);

  const [stepCounter, setStepCounter] = useState("3");
  const [sendFormLoad, setSendFormLoad] = useState(false);
  const [sendFormError, setSendFormError] = useState(false);
  const [sendFormSuccess, setSendFormSuccess] = useState(false);
  const [stepError, setStepError] = useState(null);

  const [stepOne, setStepOne] = useState(null);
  const [showStepOne, setShowStepOne] = useState(true);

  const [stepTwo, setStepTwo] = useState([]);
  const [showStepTwo, setShowStepTwo] = useState(false);

  const [stepThree, setStepThree] = useState(null);
  const [showStepThree, setShowStepThree] = useState(false);

  const [stepFour, setStepFour] = useState(null);
  const [showStepFour, setShowStepFour] = useState(false);

  const [stepFive, setStepFive] = useState({
    gender: null,
    first_name: null,
    last_name: null,
    email: null,
    dataprotection: null,
  });
  const [showStepFive, setShowStepFive] = useState(false);

  const [defaultRequest, setDefaultRequest] = useState(null);
  const [showDefaultRequest, setShowDefaultRequest] = useState(null);

  const ProductBranch = [
    "Bekleidung",
    "Elektronikartikel & Telekommunikation",
    "Computer / Zubehör / Spiele / Software",
    "Schuhe",
    "Möbel, Lampen & Dekoration",
    "Bücher / Ebooks / Hörbücher",
    "Sport & Freizeit",
    "Kosmetik",
    "Lebensmittel",
    "Sonstiges",
  ];
  const [productBranchSelect, setProductBranchSelect] = useState("");
  const [showOtherProductBranch, setShowOtherProductBranch] = useState(false);

  const CompanyBranch = [
    "KMU",
    "Einzelhandel",
    "Immobilienmanagement",
    "Gastronomie & Tourismus",
    "Produktion & Industrie",
    "Elektrotechnik & Automation",
    "Versicherungswesen",
    "Steuerberater & Anwälte",
    "Start-Ups",
    "Sonstiges",
  ];
  const [companyBranchSelect, setCompanyBranchSelect] = useState("");
  const [showOtherCompanyBranch, setShowOtherCompanyBranch] = useState(false);

  const handleStepOneChange = (event) => {
    setStepOne(event.target.value);
    setStepTwo([]);
    setStepError(null);

    if (event.target.value === "default-request") {
      setShowStepOne(false);
      setShowStepTwo(false);
      setShowStepThree(false);
      setShowStepFour(false);
      setShowDefaultRequest(true);
      setShowStepFive(false);
      setStepCounter("3");
    } else {
      setShowStepOne(false);
      setShowStepTwo(true);
      setShowStepThree(false);
      setShowStepFour(false);
      setStepCounter("5");
    }

    if (cookieAccept) {
      let title = "";
      if (event.target.value === "website-online-shop") {
        title = "Was wird benötigt";
      } else if (event.target.value === "cloud-solutions-mobile-work") {
        title = "Wie groß ist Ihr Unternehmen?";
      } else if (event.target.value === "custom-applications") {
        title = "Welche Art von Software wird benötigt?";
      } else {
        title = "Beschreibung Anforderungen";
      }

      window.dataLayer.push({
        event: "view.virtual_page",
        page_location: "https://ganzrund.com/virtual-page/lead-form/step-2",
        page_title: "Lead-Formular - Schritt 2 : " + title,
        funnel_type: event.target.value,
      });

      console.log("view-page-trigger");
    }
  };

  const handleStepTwoChange = (event) => {
    if (event.target.type === "checkbox") {
      setStepTwo((stepTwo) => [...stepTwo, event.target.value]);
      setStepThree(null);
      setStepError(null);
    } else {
      setStepTwo(event.target.value);
      setStepThree(null);
      setStepError(null);
    }
  };

  const handleStepThreeChange = (event) => {
    if (event.target.name === "branch-select") {
      setProductBranchSelect(event.target.value);
      if (event.target.value === "Sonstiges") {
        setShowOtherProductBranch(true);
      } else {
        setShowOtherProductBranch(false);
      }
    }

    setStepThree(event.target.value);
    setStepFour(null);
    setStepError(null);
  };

  const handleStepFourChange = (event) => {
    if (event.target.name === "branch-company-select") {
      setCompanyBranchSelect(event.target.value);
      if (event.target.value === "Sonstiges") {
        setShowOtherCompanyBranch(true);
      } else {
        setShowOtherCompanyBranch(false);
      }
    }

    setStepFour(event.target.value);
    setStepFive([]);
    setStepError(null);
  };

  const handleContactData = (event) => {
    let change = stepFive;
    if (event.target.name === "dataprotection") {
      change[event.target.name] = event.target.checked;
    } else {
      change[event.target.name] = event.target.value;
    }
    setStepFive(change);
  };

  const handleDefaultData = (event) => {
    setDefaultRequest(event.target.value);
  };

  const handleNextStep = (step) => {
    if (step === "stepOne" && stepOne !== null) {
      if (stepOne === "default-request") {
        setShowStepOne(false);
        setShowStepTwo(false);
        setShowStepThree(false);
        setShowStepFour(false);
        setShowDefaultRequest(true);
        setShowStepFive(false);
        setStepCounter("3");
      } else {
        setShowStepOne(false);
        setShowStepTwo(true);
        setShowStepThree(false);
        setShowStepFour(false);
        setStepCounter("5");
      }

      setStepError(null);
    } else if (step === "stepOne" && stepOne === null) {
      setStepError("Sie müssen eine Auswahl treffen!");
    }

    if (step === "stepTwo" && stepTwo.length !== 0 && stepTwo !== "") {
      setShowStepOne(false);
      setShowStepTwo(false);
      setShowStepThree(true);
      setShowStepFour(false);
      setStepError(null);

      if (cookieAccept) {
        let title = "";
        if (stepTwo === "website") {
          title = "Was soll getan werden?";
        } else if (stepTwo === "webshop") {
          title = "Welcher Branche sind ihre Produkte zuzuordnen?";
        } else if (
          stepTwo === "company-size-small" ||
          stepTwo === "company-size-middle" ||
          stepTwo === "company-size-big" ||
          stepTwo === "company-size-extra-big"
        ) {
          title = "In welcher Branche arbeiten Sie?";
        } else if (Array.isArray(stepTwo)) {
          title = "Wie groß ist Ihr Unternehmen?";
        } else {
          title = "Kontaktdaten";
        }

        window.dataLayer.push({
          event: "view.virtual_page",
          page_location: "https://ganzrund.com/virtual-page/lead-form/step-3",
          page_title: "Lead-Formular - Schritt 3 : " + title,
          funnel_type: stepOne,
        });

        console.log("view-page-trigger");
      }
    } else if (step === "stepTwo" && (stepTwo.length === 0 || stepTwo === "")) {
      setStepError("Sie müssen eine Auswahl treffen!");
    }

    if (step === "stepThree" && stepThree !== "" && stepThree !== null) {
      setShowStepOne(false);
      setShowStepTwo(false);
      setShowStepThree(false);
      setShowStepFour(true);
      setStepError(null);

      if (cookieAccept) {
        let title = "";
        if (stepThree === "new-program") {
          title = "Welche Website gefällt Ihnen optisch und technisch?";
        } else if (stepThree === "relaunch") {
          title = "Wie lautet Ihre aktuelle URL?";
        } else if (
          stepThree === "kmu" ||
          stepThree === "tax-consulting" ||
          stepThree === "law" ||
          stepThree === "other"
        ) {
          title = "Spezielle Anforderungen?";
        } else if (
          stepThree === "company-size-small" ||
          stepThree === "company-size-middle" ||
          stepThree === "company-size-big" ||
          stepThree === "company-size-extra-big"
        ) {
          title = "Welche Branche?";
        } else {
          title = "Kontaktdaten";
        }

        window.dataLayer.push({
          event: "view.virtual_page",
          page_location: "https://ganzrund.com/virtual-page/lead-form/step-4",
          page_title: "Lead-Formular - Schritt 4 : " + title,
          funnel_type: stepOne,
        });
        console.log("view-page-trigger");
      }
    } else if (
      step === "stepThree" &&
      (stepThree === "" || stepThree === null)
    ) {
      setStepError("Sie müssen eine Auswahl treffen!");
    }

    console.log(stepOne === "default-request" || stepThree !== "new-program");

    if (
      (step === "stepFour" && stepFour !== "" && stepFour !== null) ||
      (step === "stepFour" &&
        (stepOne === "default-request" ||
          stepThree === "new-program" ||
          stepThree === "tax-consulting" ||
          stepThree !== "kmu" ||
          stepThree !== "law" ||
          stepThree !== "other"))
    ) {
      setShowStepOne(false);
      setShowStepTwo(false);
      setShowStepThree(false);
      setShowStepFour(false);
      setShowDefaultRequest(false);
      setShowStepFive(true);
      setStepError(null);

      if (cookieAccept) {
        let title = "";
        if (stepFour === "new-program") {
          title = "Welche Website gefällt Ihnen optisch und technisch?";
        } else if (stepFour === "relaunch") {
          title = "Wie lautet Ihre aktuelle URL?";
        } else if (
          stepFour === "kmu" ||
          stepFour === "tax-consulting" ||
          stepFour === "law" ||
          stepFour === "other"
        ) {
          title = "Spezielle Anforderungen?";
        } else if (
          stepFour === "company-size-small" ||
          stepFour === "company-size-middle" ||
          stepFour === "company-size-big" ||
          stepFour === "company-size-extra-big"
        ) {
          title = "Welche Branche?";
        } else {
          title = "Kontaktdaten";
        }

        window.dataLayer.push({
          event: "view.virtual_page",
          page_location: "https://ganzrund.com/virtual-page/lead-form/step-5",
          page_title: "Lead-Formular - Schritt 5 : " + title,
          funnel_type: stepOne,
        });
        console.log("view-page-trigger");
      }
    } else if (
      step === "stepFour" &&
      (stepFour === "" || stepFour === null) &&
      stepThree === "relaunch" &&
      stepThree !== "new-program" &&
      stepOne !== "default-request"
    ) {
      setStepError("Sie müssen eine Auswahl treffen!");
    }
  };

  const handleBackStep = (step) => {
    if (step === "stepOne") {
      setShowStepOne(true);
      setShowStepTwo(false);
      setShowStepThree(false);
      setShowStepFour(false);
      setStepError(null);
    }

    if (step === "stepTwo") {
      setShowStepOne(false);
      setShowStepTwo(true);
      setShowStepThree(false);
      setShowStepFour(false);
      setStepError(null);
    }

    if (step === "stepThree") {
      if (stepOne === "default-request") {
        setShowStepOne(true);
        setShowStepTwo(false);
        setShowStepThree(false);
        setShowStepFour(false);
        setShowStepFive(false);
        setShowDefaultRequest(false);
        setStepError(null);
      } else {
        setShowStepOne(false);
        setShowStepTwo(false);
        setShowStepThree(true);
        setShowStepFour(false);
        setShowStepFive(false);
        setStepError(null);
      }
    }

    if (step === "stepFour" && stepOne !== "default-request") {
      setShowStepOne(false);
      setShowStepTwo(false);
      setShowStepThree(false);
      setShowStepFour(true);
      setShowStepFive(false);
      setStepError(null);
    } else if (step === "stepFour" && stepOne === "default-request") {
      setShowStepOne(false);
      setShowStepTwo(false);
      setShowStepThree(false);
      setShowStepFour(false);
      setShowStepFive(false);
      setShowDefaultRequest(true);
      setStepError(null);
    }
  };

  const handleDigestMessage = async (message) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    const hash = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hash));
    const digest = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
    return digest;
  };

  const sendRequest = () => {
    if (
      Object.values(stepFive).includes(null) ||
      Object.values(stepFive).includes("") ||
      Object.values(stepFive).includes(false)
    ) {
      setStepError("Es müssen alle Pflichtfelder ausgefüllt werden!");
    } else {
      setShowStepOne(false);
      setShowStepTwo(false);
      setShowStepThree(false);
      setShowStepFour(false);
      setShowStepFive(false);
      setShowDefaultRequest(false);

      setSendFormLoad(true);

      let data = {
        stepOne: stepOne,
        stepTwo: stepTwo,
        stepThree: stepThree,
        stepFour: stepFour,
        gender: stepFive.gender,
        first_name: stepFive.first_name,
        last_name: stepFive.last_name,
        phone: stepFive.phone,
        email: stepFive.email,
        dataprotection: stepFive.dataprotection,
      };

      axios
        .post("https://ganzrund.com/api/entry/send", data)
        .then((response) => {
          if (response !== false) {
            setTimeout(() => {
              setSendFormLoad(false);
              setSendFormError(false);
              setSendFormSuccess(true);
            }, 3000);

            if (cookieAccept) {
              handleDigestMessage(stepFive.email).then((digestBuffer) => {
                window.dataLayer.push({
                  event: "lead",
                  email: stepFive.email,
                  email_hashed: digestBuffer,
                });
              });
              console.log("lead-trigger");
            }
          } else {
            setTimeout(() => {
              setSendFormLoad(false);
              setSendFormSuccess(false);
              setSendFormError(true);
            }, 3000);
          }
        })
        .catch((response) => {
          setTimeout(() => {
            setSendFormLoad(false);
            setSendFormSuccess(false);
            setSendFormError(true);
          }, 3000);
        });

      setStepError(null);
    }
  };

  useEffect(() => {
    const element = document.getElementById("lead_form");

    if (element) {
      const checkCookiebot = setInterval(() => {
        if (typeof Cookiebot !== "undefined") {
          clearInterval(checkCookiebot);

          if (Cookiebot.consent.marketing && Cookiebot.consent.statistics) {
            setCookieAccept(true);
            console.log("Cookies accepted");

            const tagManagerArgs = {
              gtmId: "GTM-5QQN978",
            };

            TagManager.initialize(tagManagerArgs);
          } else {
            setCookieAccept(false);
          }
        }
      }, 500);
    }
  }, []);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Lf_zBclAAAAAMSEwo69dxoM5Mb_l1dxNWjNTYfA"
      language="de"
      scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }}
      container={{
        element: "gr-recaptcha",
        parameters: {
          badge: "bottomleft",
        },
      }}
    >
      <>
        <Box id="gr-recaptcha"></Box>

        {/* STEP #1 */}

        <Box sx={{ mt: 3, display: showStepOne ? "block" : "none" }}>
          <Box
            sx={{ display: "flex", flexDirection: { sm: "row", xs: "column" } }}
          >
            <Typography
              variant="h2"
              fontSize={24}
              fontWeight="bold"
              sx={{ mr: 1, color: "#8da2b2" }}
            >
              Schritt 1:
            </Typography>
            <Typography
              variant="h3"
              fontSize={24}
              fontWeight="bold"
              color="initial"
            >
              Wofür interessieren Sie sich?
            </Typography>
          </Box>
          <Box sx={{ pt: 1 }}>
            <Typography
              variant="h4"
              fontSize={19}
              fontWeight="lighter"
              color="initial"
            >
              Bitte wählen Sie eine Leistung aus:
            </Typography>
          </Box>
          <Box sx={{ mt: 2 }}>
            <RadioGroup
              name="interest-group"
              value={stepOne}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <ControlledLabelBox
                value="website-online-shop"
                onChange={handleStepOneChange}
                sx={{
                  ml: 0,
                  mr: { md: 2, sm: 1, xs: 0 },
                  width: { sm: "auto", xs: "100%" },
                }}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "left",
                      flexDirection: "column",
                      p: 4,
                      color: "#8da2b2",
                      bgcolor: "#e4eef2",
                      minHeight: { sm: "240px", xs: "150px" },
                      "& svg": { fontSize: "50px", mb: 2 },
                    }}
                  >
                    <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                      <img src={ico_website_webshop} alt="icon-01" />
                    </Box>
                    <Typography
                      variant="body1"
                      fontSize={18}
                      fontWeight="bold"
                      sx={{ wordWrap: "break-word" }}
                    >
                      Website
                    </Typography>
                    <Typography variant="body1" fontSize={18} fontWeight="bold">
                      Online-Shop
                    </Typography>
                    <Typography
                      variant="body1"
                      fontSize={15}
                      fontWeight="lighter"
                    >
                      Web Development
                    </Typography>
                  </Box>
                }
                control={<Radio sx={{ display: "none" }} />}
              />
              <ControlledLabelBox
                value="cloud-solutions-mobile-work"
                onChange={handleStepOneChange}
                sx={{
                  ml: 0,
                  mr: { md: 2, sm: 1, xs: 0 },
                  width: { sm: "auto", xs: "100%" },
                }}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "left",
                      flexDirection: "column",
                      p: 4,
                      color: "#8da2b2",
                      bgcolor: "#e4eef2",
                      minHeight: { sm: "240px", xs: "150px" },
                      "& svg": { fontSize: "50px", mb: 2 },
                    }}
                  >
                    <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                      <img src={ico_cloud} alt="icon-02" />
                    </Box>
                    <Typography variant="body1" fontSize={18} fontWeight="bold">
                      Cloud Lösung Mobiles Arbeiten
                    </Typography>
                    <Typography
                      variant="body1"
                      fontSize={15}
                      fontWeight="lighter"
                    >
                      Managed Hosting
                    </Typography>
                  </Box>
                }
                control={<Radio sx={{ display: "none" }} />}
              />
              <ControlledLabelBox
                value="custom-applications"
                onChange={handleStepOneChange}
                sx={{
                  ml: 0,
                  mr: { md: 2, sm: 1, xs: 0 },
                  width: { sm: "auto", xs: "100%" },
                }}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "left",
                      flexDirection: "column",
                      p: 4,
                      color: "#8da2b2",
                      bgcolor: "#e4eef2",
                      minHeight: { sm: "240px", xs: "150px" },
                      "& svg": { fontSize: "50px", mb: 2 },
                    }}
                  >
                    <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                      <img src={ico_dev} alt="icon-03" />
                    </Box>
                    <Typography variant="body1" fontSize={18} fontWeight="bold">
                      Individuelle Applikationen
                    </Typography>
                    <Typography
                      variant="body1"
                      fontSize={15}
                      fontWeight="lighter"
                    >
                      Application Development
                    </Typography>
                  </Box>
                }
                control={<Radio sx={{ display: "none" }} />}
              />
              <ControlledLabelBox
                value="default-request"
                onChange={handleStepOneChange}
                sx={{
                  ml: 0,
                  mr: { md: 2, sm: 1, xs: 0 },
                  width: { sm: "auto", xs: "100%" },
                }}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "left",
                      flexDirection: "column",
                      p: 4,
                      color: "#8da2b2",
                      bgcolor: "#e4eef2",
                      minHeight: { sm: "240px", xs: "150px" },
                      "& svg": { fontSize: "50px", mb: 2 },
                    }}
                  >
                    <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                      <img src={ico_contact} alt="icon-04" />
                    </Box>
                    <Typography variant="body1" fontSize={18} fontWeight="bold">
                      Allgemeine Anfrage
                    </Typography>
                    <Typography
                      variant="body1"
                      fontSize={15}
                      fontWeight="lighter"
                    >
                      Zum Kontaktformular
                    </Typography>
                  </Box>
                }
                control={<Radio sx={{ display: "none" }} />}
              />
            </RadioGroup>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
            <Button
              variant="outlined"
              sx={{ display: "none" }}
              size="large"
              onClick={() => handleBackStep("stepOne")}
            >
              Zurück
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleNextStep("stepOne")}
            >
              Weiter
            </Button>
          </Box>
        </Box>

        {/* STEP #2 */}

        <Box id="step-02" sx={{ display: showStepTwo ? "block" : "none" }}>
          <Box
            sx={{
              mt: 3,
              display: stepOne === "website-online-shop" ? "block" : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 2 / {stepCounter}:
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                Benötigen Sie eine Website oder einen Online-Shop?
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Bitte wählen Sie aus:
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <RadioGroup
                name="interest-group"
                value={stepTwo}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <ControlledLabelBox
                  value="website"
                  onChange={handleStepTwoChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_website} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Unternehmens Website
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="webshop"
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  onChange={handleStepTwoChange}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_webshop} alt="icon-06" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        eCommerce Lösung
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
              </RadioGroup>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 3,
              display:
                stepOne === "cloud-solutions-mobile-work" ? "block" : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 2 / {stepCounter}:
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                Wie groß ist Ihr Unternehmen?
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Bitte wählen Sie die Anzahl Ihrer Mitarbeiter*innen:
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <RadioGroup
                name="interest-group"
                value={stepTwo}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <ControlledLabelBox
                  value="company-size-small"
                  onChange={handleStepTwoChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_company_small} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        1-5 Personen
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="company-size-middle"
                  onChange={handleStepTwoChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_company_middle} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        6-15 Personen
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="company-size-big"
                  onChange={handleStepTwoChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_company_big} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        16-25 Personen
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="company-size-extra-big"
                  onChange={handleStepTwoChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_company_extra_big} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                        sx={{ textAlign: "center" }}
                      >
                        mehr als 25 Personen
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
              </RadioGroup>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 3,
              display: stepOne === "custom-applications" ? "block" : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 2 / {stepCounter}:
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                Welche Art von Software benötigen Sie?
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Bitte wählen Sie aus, was am ehesten zutreffend ist:
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <FormControlLabel
                  sx={{ ml: 0, mr: "16px" }}
                  value="customer-management"
                  onChange={handleStepTwoChange}
                  control={<Checkbox sx={{ display: "none" }} />}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img
                          src={ico_customer_management_program}
                          alt="icon-05"
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Kunden-
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        verwaltung
                      </Typography>
                    </Box>
                  }
                  labelPlacement="top"
                />
                <FormControlLabel
                  sx={{ ml: 0, mr: "16px" }}
                  value="invoice-program"
                  onChange={handleStepTwoChange}
                  control={<Checkbox sx={{ display: "none" }} />}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_billing_program} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Rechnungs-programm
                      </Typography>
                    </Box>
                  }
                  labelPlacement="top"
                />
                <FormControlLabel
                  sx={{ ml: 0, mr: "16px" }}
                  value="other-program"
                  onChange={handleStepTwoChange}
                  control={<Checkbox sx={{ display: "none" }} />}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_ohter_program} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Sonstiges Programm
                      </Typography>
                    </Box>
                  }
                  labelPlacement="top"
                />
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
            <Button
              variant="outlined"
              size="large"
              sx={{ mr: 2 }}
              onClick={() => handleBackStep("stepOne")}
            >
              Zurück
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleNextStep("stepTwo")}
            >
              Weiter
            </Button>
          </Box>
        </Box>

        {/* STEP #3 */}

        <Box sx={{ display: showStepThree ? "block" : "none" }}>
          <Box
            sx={{ mt: 3, display: stepTwo === "website" ? "block" : "none" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 3 / {stepCounter}:
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                Wählen Sie bitte den Leistungsumfang.
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Benötigen Sie eine neue Website oder soll eine bestehende
                überarbeitet werden?
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <RadioGroup
                name="interest-group"
                value={stepThree}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <ControlledLabelBox
                  value="new-program"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_new_program} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Neu-programierung
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={15}
                        fontWeight="lighter"
                      >
                        (keine Website vorhanden)
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="relaunch"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_relaunch} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Relaunch
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={15}
                        fontWeight="lighter"
                      >
                        (bestehende überarbeiten)
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
              </RadioGroup>
            </Box>
          </Box>

          <Box
            sx={{ mt: 3, display: stepTwo === "webshop" ? "block" : "none" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 3 / {stepCounter}:
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                Welcher Branche sind ihre Produkte zuzuordnen?
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Branche</InputLabel>
                <Select
                  labelId="branch-select-label"
                  name="branch-select"
                  id="branch-select"
                  value={productBranchSelect}
                  label="Branche"
                  onChange={handleStepThreeChange}
                >
                  {ProductBranch.map((item, index) => {
                    let label = "select-option-branch-" + index;
                    return (
                      <MenuItem key={label} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                sx={{
                  mt: 2,
                  display: showOtherProductBranch ? "inline-flex" : "none",
                }}
                fullWidth
              >
                <InputLabel>Sonstige Branche</InputLabel>
                <OutlinedInput
                  onChange={handleStepThreeChange}
                  id="branch-select-other"
                  label="Sonstige Branche"
                />
              </FormControl>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 3,
              display:
                stepTwo === "company-size-small" ||
                stepTwo === "company-size-middle" ||
                stepTwo === "company-size-big" ||
                stepTwo === "company-size-extra-big"
                  ? "block"
                  : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 3 / {stepCounter}:
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                In welcher Branche sind Sie tätig?
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Bitte wählen Sie aus, was auf Sie zutrifft:
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <RadioGroup
                name="interest-group"
                defaultValue=""
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <ControlledLabelBox
                  value="kmu"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_kmu} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        KMU
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="tax-consulting"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_tax} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Steuerberatung
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="law"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_law} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Anwaltei
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="other"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "left",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_ohter_company_type} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        Sonstiges
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
              </RadioGroup>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 3,
              display:
                stepTwo.includes("customer-management") ||
                stepTwo.includes("invoice-program") ||
                stepTwo.includes("other-program")
                  ? "block"
                  : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 3 / {stepCounter}:
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                Wie groß ist Ihr Unternehmen?
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Bitte wählen Sie die Anzahl Ihrer Mitarbeiter*innen:
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <RadioGroup
                name="interest-group"
                defaultValue=""
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <ControlledLabelBox
                  value="company-size-small"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_company_small} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        1-5 Personen
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="company-size-middle"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_company_middle} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        6-15 Personen
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="company-size-big"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_company_big} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        16-25 Personen
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="company-size-extra-big"
                  onChange={handleStepThreeChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_company_extra_big} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                        sx={{ textAlign: "center" }}
                      >
                        mehr als 25 Personen
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
              </RadioGroup>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
            <Button
              variant="outlined"
              size="large"
              sx={{ mr: 2 }}
              onClick={() => handleBackStep("stepTwo")}
            >
              Zurück
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleNextStep("stepThree")}
            >
              Weiter
            </Button>
          </Box>
        </Box>

        {/* STEP #4 */}

        <Box sx={{ display: showStepFour ? "block" : "none" }}>
          <Box
            sx={{
              mt: 3,
              display: stepThree === "new-program" ? "block" : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 4 / {stepCounter}
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Welche Website gefällt Ihnen optisch und technisch?{" "}
                <strong>(optional)</strong>
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>URL</InputLabel>
                <OutlinedInput
                  onChange={handleStepFourChange}
                  id="outlined-adornment-weight"
                  label="URL"
                />
              </FormControl>
            </Box>
          </Box>

          <Box
            sx={{ mt: 3, display: stepThree === "relaunch" ? "block" : "none" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 4 / {stepCounter}
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Wie lautet Ihre aktuelle URL?
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>URL</InputLabel>
                <OutlinedInput
                  onChange={handleStepFourChange}
                  id="outlined-adornment-weight"
                  label="URL"
                />
              </FormControl>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 3,
              display:
                stepThree !== "relaunch" &&
                stepThree !== "new-program" &&
                stepThree !== "tax-consulting" &&
                stepThree !== "kmu" &&
                stepThree !== "law" &&
                stepThree !== "other" &&
                stepThree !== "company-size-small" &&
                stepThree !== "company-size-middle" &&
                stepThree !== "company-size-big" &&
                stepThree !== "company-size-extra-big"
                  ? "block"
                  : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 4 / {stepCounter}:
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                Wie viele Produkte bieten Sie ungefähr an?
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Bitte wählen Sie aus, was am ehesten zutrifft:
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <RadioGroup
                name="interest-group"
                value={stepFour}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <ControlledLabelBox
                  value="product-size-small"
                  onChange={handleStepFourChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_product_small} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        1-10 Produkte
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="product-size-middle"
                  onChange={handleStepFourChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_product_middle} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        11-50 Produkte
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="product-size-big"
                  onChange={handleStepFourChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_product_big} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                      >
                        51-100 Produkte
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
                <ControlledLabelBox
                  value="product-size-extra-big"
                  onChange={handleStepFourChange}
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                        color: "#8da2b2",
                        bgcolor: "#e4eef2",
                        minHeight: { sm: "240px", xs: "150px" },
                        "& svg": { fontSize: "50px", mb: 2 },
                      }}
                    >
                      <Box sx={{ "& img": { height: "50px" }, mb: 1 }}>
                        <img src={ico_product_extra_big} alt="icon-05" />
                      </Box>
                      <Typography
                        variant="body1"
                        fontSize={18}
                        fontWeight="bold"
                        sx={{ textAlign: "center" }}
                      >
                        mehr als 100 Produkte
                      </Typography>
                    </Box>
                  }
                  control={<Radio sx={{ display: "none" }} />}
                />
              </RadioGroup>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 3,
              display:
                stepThree === "tax-consulting" ||
                stepThree === "kmu" ||
                stepThree === "law" ||
                stepThree === "other"
                  ? "block"
                  : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 4 / {stepCounter}
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                Haben Sie spezielle Anforderungen?
              </Typography>
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography
                variant="h4"
                fontSize={19}
                fontWeight="lighter"
                color="initial"
              >
                Teilen Sie uns z.B. mit, welche Programme (Softwaren) Sie
                verwenden möchten: <strong>(optional)</strong>
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Anforderungen</InputLabel>
                <OutlinedInput
                  onChange={handleStepFourChange}
                  id="outlined-adornment-weight"
                  label="Anforderungen"
                  multiline
                  rows={4}
                />
              </FormControl>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 3,
              display:
                stepThree === "company-size-small" ||
                stepThree === "company-size-middle" ||
                stepThree === "company-size-big" ||
                stepThree === "company-size-extra-big"
                  ? "block"
                  : "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Typography
                variant="h2"
                fontSize={24}
                fontWeight="bold"
                sx={{ mr: 1, color: "#8da2b2" }}
              >
                Schritt 4 / {stepCounter}:{" "}
              </Typography>
              <Typography
                variant="h3"
                fontSize={24}
                fontWeight="bold"
                color="initial"
              >
                In welcher Branche sind Sie tätig?
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Branche</InputLabel>
                <Select
                  labelId="branch-select-2-label"
                  id="branch-select-2"
                  name="branch-company-select"
                  value={companyBranchSelect}
                  label="Branche"
                  onChange={handleStepFourChange}
                >
                  {CompanyBranch.map((item, index) => {
                    let label = "select-option-branch-" + index;
                    return (
                      <MenuItem key={label} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                sx={{
                  mt: 2,
                  display: showOtherCompanyBranch ? "inline-flex" : "none",
                }}
                fullWidth
              >
                <InputLabel>Sonstige Branche</InputLabel>
                <OutlinedInput
                  onChange={handleStepFourChange}
                  id="branch-select-other-2"
                  label="Sonstige Branche"
                />
              </FormControl>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
            <Button
              variant="outlined"
              size="large"
              sx={{ mr: 2 }}
              onClick={() => handleBackStep("stepThree")}
            >
              Zurück
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleNextStep("stepFour")}
            >
              Weiter
            </Button>
          </Box>
        </Box>

        {/* STEP DEFAULT REQUEST */}

        <Box sx={{ display: showDefaultRequest ? "block" : "none", mt: 3 }}>
          <Box
            sx={{ display: "flex", flexDirection: { sm: "row", xs: "column" } }}
          >
            <Typography
              variant="h2"
              fontSize={24}
              fontWeight="bold"
              sx={{ mr: 1, color: "#8da2b2" }}
            >
              Schritt 2 / {stepCounter}:
            </Typography>
            <Typography
              variant="h3"
              fontSize={24}
              fontWeight="bold"
              color="initial"
            >
              Erzählen Sie uns, wonach Sie suchen!
            </Typography>
          </Box>
          <Box sx={{ pt: 1 }}>
            <Typography
              variant="h4"
              fontSize={19}
              fontWeight="lighter"
              color="initial"
            >
              Beschreiben Sie uns, welche Anforderungen Sie haben und wir
              kontaktieren Sie gerne kostenlos und unverbindlich:
            </Typography>
          </Box>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <TextField
              label="Beschreibung"
              name="description"
              onChange={handleDefaultData}
              multiline
              rows={5}
            />
          </FormControl>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => handleBackStep("stepThree")}
            >
              Zurück
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleNextStep("stepFour")}
            >
              Weiter
            </Button>
          </Box>
        </Box>

        {/* STEP #5 */}

        <Box sx={{ display: showStepFive ? "block" : "none", mt: 3 }}>
          <Box
            sx={{ display: "flex", flexDirection: { sm: "row", xs: "column" } }}
          >
            <Typography
              variant="h2"
              fontSize={24}
              fontWeight="bold"
              sx={{ mr: 1, color: "#8da2b2" }}
            >
              Letzter Schritt:
            </Typography>
            <Typography
              variant="h3"
              fontSize={24}
              fontWeight="bold"
              color="initial"
            >
              Wie dürfen wir Sie kontaktieren?
            </Typography>
          </Box>
          <Box sx={{ pt: 1 }}>
            <Typography
              variant="h4"
              fontSize={19}
              fontWeight="lighter"
              color="initial"
            >
              Bitte geben Sie Ihre Daten ein, damit wir mit Ihnen in Kontakt
              treten können:
            </Typography>
          </Box>
          <Box sx={{ mt: 2 }}>
            <FormControl sx={{ mb: 2 }}>
              <RadioGroup
                defaultValue=""
                onChange={handleContactData}
                name="gender"
                row
              >
                <FormControlLabel
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      mt: "0px !important",
                      width: "auto !important",
                      minWidth: "auto !important",
                    },
                    "& .MuiFormControlLabel-label:hover": {
                      borderColor: "transparent !important",
                    },
                  }}
                  value="mr"
                  control={<Radio />}
                  label="Herr"
                />
                <FormControlLabel
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      mt: "0px !important",
                      width: "auto !important",
                      minWidth: "auto !important",
                    },
                    "& .MuiFormControlLabel-label:hover": {
                      borderColor: "transparent !important",
                    },
                  }}
                  value="mrs"
                  control={<Radio />}
                  label="Frau"
                />
                <FormControlLabel
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      mt: "0px !important",
                      width: "auto !important",
                      minWidth: "auto !important",
                    },
                    "& .MuiFormControlLabel-label:hover": {
                      borderColor: "transparent !important",
                    },
                  }}
                  value="other"
                  control={<Radio />}
                  label="Divers"
                />
              </RadioGroup>
            </FormControl>
            <Box
              sx={{
                display: "flex",
                gap: { sm: "26px", xs: "16px" },
                mb: { sm: 3, xs: 2 },
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Vorname*</InputLabel>
                <OutlinedInput
                  onChange={handleContactData}
                  name="first_name"
                  id="outlined-adornment-weight"
                  label="Vorname*"
                />
              </FormControl>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Nachname*</InputLabel>
                <OutlinedInput
                  onChange={handleContactData}
                  name="last_name"
                  id="outlined-adornment-weight"
                  label="Nachname*"
                />
              </FormControl>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: { sm: "26px", xs: "16px" },
                mb: { sm: 3, xs: 2 },
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Telefonnummer</InputLabel>
                <OutlinedInput
                  onChange={handleContactData}
                  name="phone"
                  id="outlined-adornment-weight"
                  label="Telefonnummer*"
                />
                <FormHelperText
                  sx={{
                    ml: 0,
                    mr: { md: 2, sm: 1, xs: 0 },
                    width: { sm: "auto", xs: "100%" },
                  }}
                >
                  Telefonnummer, unter der wir Sie zwischen 08:00-17:00 Uhr
                  erreichen können. (Optional)
                </FormHelperText>
              </FormControl>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>E-Mail Adresse*</InputLabel>
                <OutlinedInput
                  onChange={handleContactData}
                  name="email"
                  id="outlined-adornment-weight"
                  label="E-Mail Adresse*"
                />
              </FormControl>
            </Box>
            <FormControlLabel
              sx={{
                "& .MuiCheckbox-root.Mui-checked + .MuiFormControlLabel-label":
                  { border: "none !important" },
                ".MuiFormControlLabel-label": {
                  border: "none !important",
                  mt: "0 !important",
                  maxWidth: "100% !important",
                  ml: { sm: "0", xs: "12px !important" },
                },
                flexDirection: { sm: "row", xs: "column" },
                justifyContent: { sm: "center", xs: "flex-start" },
                alignItems: { sm: "center", xs: "flex-start" },
              }}
              onChange={handleContactData}
              name="dataprotection"
              control={<Checkbox />}
              label={
                <>
                  <Typography variant="body1" fontSize={15} color="initial">
                    Ich akzeptiere die{" "}
                    <a href="https://ganzrund.com/agb/" target="_blank">
                      Allgemeinen Geschäftsbedingungen
                    </a>{" "}
                    sowie die{" "}
                    <a href="https://ganzrund.com/datenschutz/" target="_blank">
                      Datenschutzbestimmungen
                    </a>
                    . Ich habe das Recht zur Kenntnis genommen, meine
                    Einwilligung zur Datenverarbeitung zu widerrufen.*
                  </Typography>
                </>
              }
            />
            <Box sx={{ mt: 5 }}>
              <Typography variant="body1" fontSize={15} color="initial">
                Die mit * gekennzeichneten Felder sind Pflichfelder.
              </Typography>
              <Button
                variant="outlined"
                sx={{ mt: 2, mr: 2 }}
                size="large"
                onClick={() => handleBackStep("stepFour")}
              >
                Zurück
              </Button>
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                size="large"
                onClick={sendRequest}
              >
                Meine Anfrage absenden
              </Button>
            </Box>
          </Box>
        </Box>

        {stepError !== null ? (
          <Box sx={{ mt: 2 }}>
            <Typography
              variant="h6"
              fontSize={16}
              fontWeight="bold"
              color="error"
            >
              {stepError}
            </Typography>
          </Box>
        ) : (
          <></>
        )}

        {sendFormLoad === true ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 4,
              minHeight: "400px",
              bgcolor: "#80808029",
              flexDirection: "column",
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Comment
                visible={true}
                height="80"
                width="80"
                ariaLabel="comment-loading"
                wrapperStyle={{}}
                wrapperClass="comment-wrapper"
                color="#fff"
                backgroundColor="rgb(59, 86, 110)"
              />
            </Box>
            <Typography variant="h3" color="initial">
              Daten werden verarbeitet.
            </Typography>
          </Box>
        ) : (
          <></>
        )}

        {sendFormError === true ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 4,
              minHeight: "400px",
              bgcolor: "#80808029",
              flexDirection: "column",
            }}
          >
            <Box sx={{ "& svg": { fontSize: "50px", color: "red" }, mb: 2 }}>
              <DoDisturbOnIcon />
            </Box>
            <Typography variant="h3" color="initial">
              Es gab leider ein Fehler beim Übermitteln der Daten.
            </Typography>
          </Box>
        ) : (
          <></>
        )}

        {sendFormSuccess === true ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 4,
              minHeight: "400px",
              bgcolor: "#80808029",
              flexDirection: "column",
            }}
          >
            <Box sx={{ "& svg": { fontSize: "50px", color: "green" }, mb: 2 }}>
              <CheckCircleIcon />
            </Box>
            <Typography variant="h3" color="initial">
              Formular wurde erfolgreich versendet.
            </Typography>
          </Box>
        ) : (
          <></>
        )}
      </>
    </GoogleReCaptchaProvider>
  );
};

export default StepperForm;
